<template>
  <div class="new_vip">
    <div class="content">
      <div class="options">
        <div class="options_item">
          会员卡号 
          <el-input v-model="keyword" class="input_box" size="small"></el-input>
        </div>
        <div class="options_item">
          <el-button type="primary" size="small">查询</el-button>
        </div>
        <div class="options_item">
          <el-button size="small">导出</el-button>
        </div>
        <div class="options_item">
          <el-button size="small">打印</el-button>
        </div>
        <div class="options_item">
          <el-button size="small">导入</el-button>
        </div>
      </div>
      <div class="stat_box">
        <div class="stat_item" style="background: #6C85FF">
          <div class="stat_item_left">
            <div class="stat_item_line">今日新增</div>
            <div class="stat_item_line"><span>0</span>车队</div>
          </div>
          <div class="stat_item_right">
            <div class="stat_item_line">本周<span>0</span>车队</div>
            <div class="stat_item_line">本月<span>1</span>车队</div>
          </div>
        </div>
        <div class="stat_item" style="background: #00D1A6">
          <div class="stat_item_left">
            <div class="stat_item_line">本周未消费</div>
            <div class="stat_item_line"><span>16</span>车队</div>
          </div>
          <div class="stat_item_right">
            <div class="stat_item_line">本月<span>14</span>车队</div>
            <div class="stat_item_line">近三月<span>3</span>车队</div>
          </div>
        </div>
        <div class="stat_item" style="background: #72BDFF">
          <div class="stat_item_left">
            <div class="stat_item_line">今日到期</div>
            <div class="stat_item_line"><span>0</span>车队</div>
          </div>
          <div class="stat_item_right">
            <div class="stat_item_line">未来7填<span>0</span>车队</div>
            <div class="stat_item_line">未来30天<span>0</span>车队</div>
          </div>
        </div>
      </div>
      <div class="table_content">
        <el-table
          ref="multipleTable"
          :data="tableData"
          style="width: 100%;height: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="卡号" prop="card_no" v-if="showTableItems[0].show"></el-table-column>
          <el-table-column label="车队" prop="name" v-if="showTableItems[1].show"></el-table-column>
          <el-table-column label="等级" prop="level" v-if="showTableItems[2].show"></el-table-column>
          <el-table-column label="售卡金额" prop="money" v-if="showTableItems[3].show"></el-table-column>
          <el-table-column label="手机" prop="mobile" v-if="showTableItems[4].show"></el-table-column>
          <el-table-column label="余额" prop="balance" v-if="showTableItems[5].show"></el-table-column>
          <el-table-column label="积分" prop="point" v-if="showTableItems[6].show"></el-table-column>
          <el-table-column label="累计消费" prop="stat_money" v-if="showTableItems[7].show"></el-table-column>
          <el-table-column label="累计积分" prop="stat_point" v-if="showTableItems[8].show"></el-table-column>
          <el-table-column label="所属分店" prop="shop" v-if="showTableItems[9].show"></el-table-column>
          <el-table-column width="70px;">
            <template slot="header">
              <el-popover
                placement="bottom"
                width="120"
                trigger="click">
                <el-checkbox style="margin-bottom:10px" v-for="(item,index) in showTableItems" :key="index" v-model="item.show">{{item.name}}</el-checkbox>
                <el-button slot="reference" size="small" icon="el-icon-s-unfold"></el-button>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      params: { //查询条件
        day: "30", //天数
        shop: "", //店铺id
      },
      shop_options: [], //店铺选项
      tableData: [], //表格数据
      multipleSelection: [], //表格选中项
      showTableItems: [
        {name: "卡号",show: true},
        {name: "车队",show: true},
        {name: "等级",show: true},
        {name: "售卡金额",show: true},
        {name: "手机",show: true},
        {name: "余额",show: true},
        {name: "积分",show: true},
        {name: "累计消费",show: true},
        {name: "累计积分",show: true},
        {name: "分店",show: true},
      ], //表格显示内容
      page: 1, //页码
      total: 0, //总数
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCurrentChange(val) {
      console.log(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.new_vip{
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
  .content{
    background: #fff;
    padding: 24px;
    height: 100%;
    display: flex;
    flex-direction: column;
    .options{
      display: flex;
      line-height: 50px;
      .options_item{
        margin-left: 12px;
      }
      .short_input{
        width: 52px;
      }
      .input_box{
        width: 180px;
      }
    }
    .stat_box{
      padding: 20px 0;
      display: flex;
      justify-content: space-between;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
      .stat_item{
        width: 30%;
        display: flex;
        height: 90px;
        border-radius: 10px;
        padding:12px;
        color: #fff;
        .stat_item_left{
          flex:2;
          border-right: 1px solid #fff;
        }
        .stat_item_right{
          flex:3;
        }
        .stat_item_line{
          line-height: 33px;
          text-align: center;
          span{
            font-weight: blod;
          }
        }
      }
    }
    .table_content{
      flex: 1;
      margin-top: 20px;
    }
    .page{
      margin-top: 15px;
      text-align: right;
    }
  }
}
</style>